import Http from '@wk/http';
import config from 'configDir/index';
import Vue from 'vue';
import qs from 'qs';
import { routerGo, Storage } from '@wk/core';
import { Modal } from 'ant-design-vue';
import { TwoFactor2 } from '@wk-libs/twoFactor';
import store from '@/store';

const twoFactorInstance = new TwoFactor2({
  baseUrl: config.hostUrl,
});
let timer = null;

const http = new Http({
  axios: '',
  axiosOptions: { timeout: 30000, withCredentials: false },
  requestInterceptorSuccessCb: (res) => {
    const request = res;
    const loginUser = Vue.prototype.$storage.get('LOGIN_USER') || {};
    if (loginUser.authorization) {
      request.headers.Authorization = loginUser.authorization;
    }

    if (!res.params) {
      res.params = {
        t: new Date().getTime(),
      };
    }
    // 查询参数去空格
    if (res.params) {
      Object.keys(res.params).forEach((key) => {
        if (typeof res.params[key] === 'string') {
          res.params[key] = res.params[key].trim();
        }
      });
      res.params.t = new Date().getTime();
    }
    return request;
  },
  responseInterceptorSuccessCb: (res) => {
    if (Storage.get('LOGIN_USER') && res.status && res.headers.two_factor_projectid) {
      const { authorization } = Storage.get('LOGIN_USER');
      twoFactorInstance.open(res.status, authorization, res.headers.two_factor_projectid);
    }
    return res.data;
  },
  responseInterceptorErrorCb: (res) => {
    const { response } = res || {};
    let trueFlag = false;
    if (Storage.get('LOGIN_USER') && response.headers.two_factor_projectid) {
      const { authorization } = Storage.get('LOGIN_USER');
      twoFactorInstance.open(response.status, authorization, response.headers.two_factor_projectid);
    }
    if (response && response.status === 401) {
      Vue.prototype.$message.destroy();
      Modal.destroyAll();
      if (response.data.code === '401.2') {
        if (response.data.message === '由于您长时间未操作，请重新登陆！') {
          Modal.warning({
            title: '由于您长时间未操作，请重新登陆！',
            onOk() {
              Storage.set('LOGIN_USER', {});
              store.dispatch('StoreUser/setLoginUser', {});
              Storage.set('AUTHORITY_MENU', []);
              Storage.set('AUTHORITY_ALL', []);
              Storage.set('PATH_ALL', []);
              store.dispatch('StoreMenu/setMenu', []);
              console.log(routerGo);
              window.location.href = `${window.location.origin}/userCenter/login`;
            },
          });
        } else {
          Vue.prototype.$message.error(response.data.message);
          trueFlag = true;
        }
      } else {
        Vue.prototype.$message.error('登录超时，请重新登录');
        trueFlag = true;
      }
      if (trueFlag && window.location.href.indexOf('/userCenter/login') === -1) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
          Storage.set('LOGIN_USER', {});
          store.dispatch('StoreUser/setLoginUser', {});
          Storage.set('AUTHORITY_MENU', []);
          Storage.set('AUTHORITY_ALL', []);
          Storage.set('PATH_ALL', []);
          store.dispatch('StoreMenu/setMenu', []);
          console.log(routerGo);
          window.location.href = `${window.location.origin}/userCenter/login`;
        }, 1000);
      }
      // routerGo('/userCenter/login', '登录');
    }
    return res;
  },
});

export function getOutApi(serviceUrl) {
  const url = `${serviceUrl}`;
  return (params = {}) => {
    const expand = {
      paramsSerializer: (param) => qs.stringify(param, { arrayFormat: 'repeat' }),
    };
    const options = { url, params, ...expand };
    return http.get(options);
  };
}

export function get(serviceUrl, baseURL = config.serviceUrl) {
  const url = `${baseURL}${serviceUrl}`;
  return (params = {}) => {
    const expand = {
      paramsSerializer: (param) => qs.stringify(param, { arrayFormat: 'repeat' }),
    };
    const options = { url, params, ...expand };
    return http.get(options);
  };
}

export function post(serviceUrl, baseURL = config.serviceUrl) {
  const url = `${baseURL}${serviceUrl}`;
  return (data, params = {}) => http.post({ url, data, params });
}

export function put(serviceUrl, baseURL = config.serviceUrl) {
  const url = `${baseURL}${serviceUrl}`;
  return (data) => http.put({ url, data });
}

export function putQuery(serviceUrl, baseURL = config.serviceUrl) {
  const url = `${baseURL}${serviceUrl}`;
  return (params) => {
    console.log(params);
    const expand = {
      paramsSerializer: (param) => qs.stringify(param, { arrayFormat: 'repeat' }),
    };
    return http.put({ url, params, ...expand });
  };
}

export function del(serviceUrl, baseURL = config.serviceUrl) {
  const url = `${baseURL}${serviceUrl}`;
  return (params = {}, data) => {
    if (data) {
      return http.del({ url, data });
    }
    return http.del({ url, params });
  };
}
